import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, FileText, FileCheck, User, LogOut } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

const navItems = [
  { to: '/portal', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/portal/invoices', icon: FileText, label: 'Invoices' },
  { to: '/portal/quotes', icon: FileCheck, label: 'Quotes' },
  { to: '/portal/profile', icon: User, label: 'Profile' },
];

export default function PortalLayout({ children }: { children: React.ReactNode }) {
  const { logout, company } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-full bg-fieldiq-dark">
      {/* Top Header */}
      <header className="z-40 bg-fieldiq-dark/95 backdrop-blur border-b border-fieldiq-border px-4 py-3 safe-top">
        <div className="max-w-5xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            {company?.logoUrl && (
              <img src={company.logoUrl} alt="" className="h-8 rounded" />
            )}
            <div>
              <h1 className="text-white font-bold text-lg leading-tight">{company?.name || 'Customer Portal'}</h1>
              <p className="text-xs text-fieldiq-muted">Customer Portal</p>
            </div>
          </div>
          <button onClick={handleLogout} className="text-fieldiq-muted hover:text-white transition-colors p-2">
            <LogOut size={20} />
          </button>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-4 py-4 pb-[var(--bottom-chrome)]">
        {children}
      </main>

      {/* Bottom Nav */}
      <nav className="fixed bottom-0 left-0 right-0 bg-fieldiq-dark border-t border-fieldiq-border z-40 safe-bottom">
        <div className="max-w-5xl mx-auto flex justify-around py-2">
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/portal'}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-1 px-3 text-xs transition-colors ${
                  isActive ? 'text-fieldiq-accent' : 'text-fieldiq-muted hover:text-white'
                }`
              }
            >
              <Icon size={20} />
              <span>{label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
